import React from 'react';
import { View, Dimensions } from 'react-native';

import { isObject as _isObject } from 'lodash';
import moment from 'moment';
import PropTypes from 'prop-types';

import { VFText } from '@vfgroup-oneplatform/foundation/Components';
import { withTheme, LightThemeColors } from '@vfgroup-oneplatform/foundation/Components/Themes';
import { DateCurrencyFromatter } from '@vfgroup-oneplatform/foundation/Utils';

import styles from './TimelineBar.Styles';

function TimelineBar({ date, slot, theme }) {
  const today = moment();
  const { dateFormats, dateTransformer } = DateCurrencyFromatter.dateCurrencyFromatter;
  const isToday = date.date == dateTransformer(today, dateFormats.calendarFormat);
  const setBarDate = _date => {
    if (_isObject(_date) && _date.isMainBar) {
      return dateTransformer(_date.date, dateFormats.shortDate);
    }
    return '';
  };
  return (
    <View style={styles.container(slot)}>
      <VFText
        style={styles.barText(isToday, theme)}
        i18nKey={isToday ? 'addons_timeline_today' : setBarDate(date)}
      />
      <View style={styles.barCircle(isToday, theme)} />
      <View style={styles.barLine(isToday, theme)} />
    </View>
  );
}
TimelineBar.defaultProps = {
  theme: LightThemeColors,
  slot: Dimensions.get('window').width / 6,
};
TimelineBar.propTypes = {
  date: PropTypes.object,
  slot: PropTypes.number,
  theme: PropTypes.shape({
    name: PropTypes.string,
    isDark: PropTypes.bool,
    colors: PropTypes.object,
  }),
};
export default withTheme(TimelineBar);
